import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { email } from '@config';
import { Side } from '@components';

const StyledLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  a {
    margin: 20px auto;
    padding: 10px;
    font-family: var(--font-mono);
    font-size: var(--fz-xxs);
    line-height: var(--fz-lg);
    letter-spacing: 0.1em;
    writing-mode: vertical-rl;
    color: #ffffff;
    transition: var(--transition);
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));

    &:focus {
      outline: none;
      color: #ffffff;
      transform: none;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));
    }

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        transform: translateY(-3px);
        color: #ff2a2a;
        filter: drop-shadow(0 0 5px rgba(255, 42, 42, 0.5));
      }
    }
    &:active,
    &.touch-active {
      transform: translateY(-3px);
      color: #ff2a2a;
      filter: drop-shadow(0 0 5px rgba(255, 42, 42, 0.5));
    }
  }

  @media (max-height: 450px) and (orientation: landscape) {
    &:after {
      height: 30px;
    }
  }
`;

const Email = ({ isHome }) => (
  <Side isHome={isHome} orientation="right">
    <StyledLinkWrapper>
      <a href={`mailto:${email}`} onClick={e => e.currentTarget.blur()}>
        {email}
      </a>
    </StyledLinkWrapper>
  </Side>
);

Email.propTypes = {
  isHome: PropTypes.bool,
};

export default Email;
